export default __webpack_public_path__ + "images/f586030ae346497d3d321e6203efeead.svg";